export default {"src":"/_next/static/media/commercial-icon.c1453eff.svg","height":95,"width":75,"blurWidth":0,"blurHeight":0};